/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AuthorizationCodeRequest interface.
 */
export function instanceOfAuthorizationCodeRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "authorizationCode" in value;
    isInstance = isInstance && "scopes" in value;
    isInstance = isInstance && "redirectUri" in value;
    return isInstance;
}
export function AuthorizationCodeRequestFromJSON(json) {
    return AuthorizationCodeRequestFromJSONTyped(json, false);
}
export function AuthorizationCodeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        authorizationCode: json.authorizationCode,
        scopes: json.scopes,
        redirectUri: json.redirectUri,
    };
}
export function AuthorizationCodeRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        authorizationCode: value.authorizationCode,
        scopes: value.scopes,
        redirectUri: value.redirectUri,
    };
}
